import { useEducationInfoControllerGetInfoQuery } from '@api/admin/adminGeneratedApi';

export const useGetForms = () => {
  const { data, isLoading } = useEducationInfoControllerGetInfoQuery({ type: 'forms' });

  return { data, isLoading };
};
